module.exports = __webpack_public_path__ + "static/media/611EsK7rWIL._AC_SL1000_.48ba6bf0.jpg";